import * as types from './types';
import actions from './actions';
import {
  extend,
} from 'lodash';
import {ToolBookStatementDetailModel} from "../../../../model";

const state = {

  bookStatementCollegeTotalModel: {
    state: '',
  },
  bookStatementDetailModel: {
    state: ''
  }
};

const getters = {

  getBookStatementCollegeTotalModel: (state) =>state.bookStatementCollegeTotalModel,
  getBookStatementDetailModel: (state) => state.bookStatementDetailModel,

};

const mutations = {

  //领书申请教材详情列表
  [types.ACTION_TOOL_BOOK_STATEMENT_COLLEGE_TOTAL_DETAIL](state, result){
    state.bookStatementCollegeTotalModel = extend({}, result);
  },
  [types.ACTION_TOOL_BOOK_STATEMENT_DETAIL_MODEL](state, result){
    state.bookStatementDetailModel = extend({}, result);
  },
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/settlementMoney/index.js